import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import {
    Translation
} from '../../features/translations/getTranslation'

export default function AlertDialog(props: any) {
    const open = props.alertActive;
    const setOpen = props.setAlertActive;

    const handleClose = (agreement: any) => {
        setOpen(false);
    };
    return (
        <div>
            <Dialog open={open} onClose={handleClose} aria-labelledby="responsive-dialog-title">
                <DialogTitle id="responsive-dialog-title">{Translation.t(props.info.title)}</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        {Translation.t(props.info.message)}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => handleClose(true)} color="secondary">{Translation.t("CONFIRM")}</Button>
                </DialogActions>
            </Dialog>
        </div>
    );
}